/**
 * This is a stub for `monaco-yaml/lib/esm/schemaSelectionHandlers.js`.
 */
export function JSONSchemaSelection(): undefined {
  // This is a stub
}
